import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MarketingInfo.css";
import marketingImg from "../../assets/event-0.jpg";

const MarketingInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
        <Row className="g-4">
          {/* Left Section */}
          <Col lg={8} className="slide-in-left">
            <h1 className="text-primary2 fw-bold mb-4 text-center text-lg-start">
              Marketing Events
            </h1>
            <Row className="g-3 align-items-center">
              <Col xs={12} md={6}>
                <img
                  src={marketingImg}
                  alt="Marketing"
                  className="img-fluid mb-3 company-image"
                />
              </Col>
              <Col xs={12} md={6} className="text-white">
                <h4 className="text-white mt-3 mb-3 text-center text-md-start">
                  Our Marketing Services
                </h4>
                <ul className="event-services-list ps-3">
                  <li>On-Ground Marketing Activations</li>
                  <li>Brand Launches</li>
                  <li>Promotional Campaigns</li>
                  <li>Experiential Marketing Events</li>
                  <li>Product Sampling Events</li>
                  <li>Sponsorship Activations</li>
                  <li>Product Demonstrations</li>
                </ul>
              </Col>
            </Row>
            <p className="text-white mt-4">
              Welcome to Zarinova Entertainment, your premier destination for
              exceptional marketing events services. At Zarinova, we understand
              that a successful event is more than just an occasion; it's an
              experience that leaves a lasting impression. With years of
              expertise in crafting unforgettable events, we pride ourselves on
              our ability to bring your vision to life, whether it’s a product
              launch, corporate gala, trade show, or promotional event.
            </p>
          </Col>

          {/* Right Section */}
          <Col lg={4} className="slide-in-right">
            <Card className="get-in-touch-card1 mt-4">
              <Card.Body>
                <h5 className="fw-bold text-white">GET IN TOUCH</h5>
                <p className="small text-white">
                  PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION
                </p>
                <Form>
                  <Form.Group className="mb-3" controlId="formFullName">
                    <Form.Control type="text" placeholder="FULL NAME" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control type="email" placeholder="EMAIL ADDRESS" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formComment">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="YOUR COMMENT"
                    />
                  </Form.Group>

                  <Button
                    variant="warning1"
                    className="learn-more-btn rounded-pill px-4 py-2 text-white w-100"
                    type="submit"
                  >
                    SUBMIT
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MarketingInfo;
